import { render, staticRenderFns } from "./stockbatch_edit.vue?vue&type=template&id=077eed02&scoped=true"
import script from "./stockbatch_edit.vue?vue&type=script&lang=js"
export * from "./stockbatch_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077eed02",
  null
  
)

export default component.exports